var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "400px",
        title: "Create User",
        visible: _vm.dialogVisible,
        scrollbar: false,
        "z-index": 2000,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.onOpened,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "roleID", label: "Role" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Please select role" },
                  on: { change: _vm.onRoleChange },
                  model: {
                    value: _vm.form.roleID,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "roleID", $$v)
                    },
                    expression: "form.roleID",
                  },
                },
                _vm._l(_vm.roleList, function (item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { value: item.RoleID, label: item.RoleName },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.supervisorVisible
            ? _c(
                "el-form-item",
                { attrs: { prop: "supervisorId", label: "Manager" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "Please select manager",
                        disabled: _vm.supervisorDisabled,
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.supervisorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supervisorId", $$v)
                        },
                        expression: "form.supervisorId",
                      },
                    },
                    _vm._l(_vm.supervisors, function (item, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { value: item.UserID, label: item.Name },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.taVisible
            ? _c(
                "el-form-item",
                { attrs: { prop: "taId", label: _vm.taLabel } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.taMessage, filterable: "" },
                      model: {
                        value: _vm.form.taId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taId", $$v)
                        },
                        expression: "form.taId",
                      },
                    },
                    _vm._l(_vm.taList, function (item, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { value: item.TAID, label: item.TAName },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.teamNameVisible
            ? _c(
                "el-form-item",
                { attrs: { prop: "teamName", label: "Team" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input team name",
                      autocomplete: "off",
                      maxlength: "50",
                    },
                    model: {
                      value: _vm.form.teamName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "teamName", $$v)
                      },
                      expression: "form.teamName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { prop: "name", label: "Name" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Please input name",
                  maxlength: "20",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "loginName", label: "LoginName" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Please input login Name",
                  maxlength: "25",
                  autocomplete: "off",
                },
                on: { input: _vm.onLoginNameInput },
                model: {
                  value: _vm.form.loginName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "loginName", $$v)
                  },
                  expression: "form.loginName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "email", label: "Email" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Please input email",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "phone", label: "Phone" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Please input phone",
                  maxlength: "20",
                  autocomplete: "off",
                },
                on: { input: _vm.onPhoneInput },
                model: {
                  value: _vm.form.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone",
                },
              }),
            ],
            1
          ),
          _vm.showTA
            ? _c(
                "el-form-item",
                { attrs: { prop: "taConfigId", label: "TA" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "Please select TA",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.taConfigId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taConfigId", $$v)
                        },
                        expression: "form.taConfigId",
                      },
                    },
                    _vm._l(_vm.taConfitList, function (item) {
                      return _c("el-option", {
                        key: item.taConfigId,
                        attrs: {
                          label: item.taConfigName,
                          value: item.taConfigId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(" Submit" + _vm._s(_vm.loading ? "ting" : "") + " ")]
          ),
          _c("el-button", { on: { click: _vm.onClosed } }, [_vm._v("Cancel")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }